import { SimState } from '../@types/State';
import { draftRates, rituals } from '../helpers/GameAgeData';

export const defaultBuild: SimState = {
  buildIndex: 0,
  buildName: 'Snapshot 1',
  raceCombo: undefined,
  title: 'Peasant',
  ritual: JSON.stringify(rituals[0]),
  draftRate: JSON.stringify(draftRates[1]),
  server: 1,
  be: 100,
  ritEff: 100,
  acres: 400,
  wages: 100,
  money: 0,
  food: 0,
  runes: 0,
  horses: 0,
  soldiers: 0,
  soldiersTraining: 0,
  wizards: 0,
  dSpecs: 0,
  oSpecs: 0,
  thieves: 0,
  elites: 0,
  prisoners: 0,
  targetDraft: 68,
  science: {
    alchemy: 0,
    tools: 0,
    housing: 0,
    production: 0,
    bookkeeping: 0,
    artisan: 0,
    strategy: 0,
    siege: 0,
    tactics: 0,
    valor: 0,
    heroism: 0,
    resilience: 0,
    crime: 0,
    channeling: 0,
    shielding: 0,
    cunning: 0,
    sorcery: 0,
    finesse: 0,
  },
  buildPercentages: {
    barren: 0,
    homes: 0,
    farms: 0,
    mills: 0,
    banks: 0,
    trainingGrounds: 0,
    armouries: 0,
    barracks: 0,
    forts: 0,
    castles: 0,
    hospitals: 0,
    guilds: 0,
    towers: 8,
    thievesDens: 0,
    watchTowers: 0,
    universities: 0,
    libraries: 0,
    stables: 0,
    dungeons: 0,
  },
  spells: [],
  training: {
    rawTpa: 2.5,
    dspa: 6,
    gcpa: 500,
    soldiers: 0,
    razePcnt: 80,
    buildCredits: 0,
    trainCredits: 0,
  },
};
